
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's1488e73779d7682f': `1) Abre el menú de tu navegador`,
's182ab2d6c997515f': `Añádelo a tu pantalla de inicio para una experiencia amplia y acceso fácil.`,
's1b9047d53d9f9d22': `2) Presionar Compartir en la barra de direcciones`,
's2d90afa5dcca2c0e': `3) Desplázate hacia abajo hasta "Añadir a pantalla de inicio"`,
's37a9e8aec5713460': `Más`,
's4593f304dac8848c': `2) Toca "Añadir a pantalla de inicio"`,
's54cfbb14f46396d4': `1) Abre en tu navegador principal`,
's6196153c4b0c1ea0': `Instalar`,
's922329d6f6213590': `Añadir al Dock`,
'sa5ef80b4bb9b39f8': `Menos`,
'sa7551383d1897fcc': `2) Presionar Añadir al Dock`,
'sba52286c21552a4e': `Instálalo en tu dispositivo para una experiencia amplia y acceso fácil.`,
'sc79fd7641eb9a975': `Esconder instrucciones`,
'scdaf4bbff76674c8': `Añadir a pantalla de inicio`,
'se740f75b95a51807': `Añádelo a tu Dock para una experiencia amplia y acceso fácil.`,
'sfea652f6580ff086': `Este sitio tiene funcionalidad de aplicación.`,
    };
  